import { getApiKey } from "../../utils/apiKey";
import { useEffect, useState } from "react";
import Header from "../header";
import axios from "axios";
import { apiCall_domainV2 } from "../api";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";
import Spinner from "../Spinner/Spinner";
import { Link } from "react-router-dom";

const Evaluation = () => {
  const [evaluations, setEvaluation] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    setLoading(true);
    axios
      .get(`${apiCall_domainV2}/customer/evaluations/list`, {
        headers: headers,
      })
      .then((res) => {
        setEvaluation(res.data.data);
        setLoading(false);
      });
  }, []);
  return (
    <>
      <Header showSearchBar={true} title={"ارزیابی ها"} isDarkTheme={true} />
      <div className="evaluationList">
        {!loading ? (
          evaluations.length ? (
            evaluations.map((ev, index) => (
              <Accordion className="accordion-container">
                <AccordionSummary>
                  <div className="AccordionSummary">
                    <div className="license-plate">
                      <div className="plate-wrapper">
                        <div className="input-section">
                          <div className="input-group flex-nowrap">
                            <span className="country-label">ایران</span>
                            <input
                              value={ev.number.slice(0, 2)}
                              disabled
                              maxLength={2}
                              type="text"
                              className="input-field"
                              placeholder="_ _"
                            />
                          </div>
                          <div className="input-group">
                            <input
                              value={ev.number.slice(2, 5)}
                              maxLength={3}
                              type="text"
                              className="input-field"
                              placeholder="_ _ _"
                            />
                          </div>
                          <div className="input-group">
                            <input
                              type="text"
                              value={ev.word}
                              maxLength={1}
                              className="input-field"
                              placeholder="حروف"
                            />
                          </div>
                          <div className="input-group">
                            <input
                              value={ev.region_number}
                              type="text"
                              maxLength={2}
                              className="input-field"
                              placeholder="_ _"
                            />
                          </div>
                        </div>
                        {/* <div className="country-flag">
                          <img
                            src="/public/assets/img/LicensePlateCountry.svg"
                            alt="Country Flag"
                            className="flag-image"
                          />
                        </div> */}
                      </div>
                    </div>
                    <i className="icon-chevron-down" />
                    {/* <img
                      src="/public/assets/img/profile/wallet.svg"
                      alt="alt"
                    /> */}
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="evaluations">
                    {ev.dates.length ? (
                      ev.dates.map((d) => (
                        <Link
                          to={`/evaluation/${d.id}`}
                          key={d.id}
                          className="evaluation-item"
                        >
                          ارزیابی ثبت شده در{" "}
                          <span dir="ltr">{d.created_at}</span>
                        </Link>
                      ))
                    ) : (
                      <span>هیچ ارزیابی انجام نشده تسن</span>
                    )}
                  </div>
                </AccordionDetails>
              </Accordion>
            ))
          ) : (
            <span className="d-flex align-items-center justify-content-center my-auto">
              لیست ارزیابی خالی است
            </span>
          )
        ) : (
          <Spinner />
        )}
      </div>
    </>
  );
};

export default Evaluation;
